import { Star } from "lucide-react";

export const METRIC_LABELS = {
  session_completion: "Session completion",
  pain_improvement: "Pain improvement",
  attendance_rate: "Attendance",
  punctuality: "Punctuality",
  report_timeliness: "Report timeliness",
  case_completion: "Case completion",
};

export const METRIC_HELP = {
  session_completion: "Closed cases: sessions done ÷ sessions prescribed",
  pain_improvement: "Avg drop from first to latest pain score per case",
  attendance_rate: "Days present ÷ days marked by Ops",
  punctuality: "On-time days ÷ present days",
  report_timeliness: "Visit reports submitted the same day as the visit",
  case_completion: "Closed cases finished as Completed",
};

export function ScoreBadge({ score, isNew, testid }) {
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testid}>
      <span className="metric font-extrabold text-slate-900">{score ?? "—"}{score != null && <span className="text-[11px] font-semibold text-slate-400">/100</span>}</span>
      {isNew && <span className="rounded-full bg-sky-50 text-sky-700 text-[10.5px] font-bold px-1.5 py-0.5">New</span>}
    </span>
  );
}

export function StarRating({ value, count, testid }) {
  if (!count) return <span className="text-[11.5px] text-slate-400" data-testid={testid}>No patient ratings yet</span>;
  return (
    <span className="inline-flex items-center gap-1 text-[12px]" data-testid={testid}>
      <Star size={13} className="text-amber-500" fill="currentColor" />
      <b className="text-slate-800">{value}</b><span className="text-slate-400">({count})</span>
    </span>
  );
}
